module.exports = {"410972060":"昆吾路街道","410972061":"皇甫路街道","410972062":"开州街道","410972063":"濮上街道","410972100":"王助镇","410972101":"新习镇","410972360":"胡村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410972.json
// module id = 1615
// module chunks = 0